module.exports = __webpack_public_path__ + "img/blackjack.a12545e1.webp";